import { makeStyles } from '@material-ui/styles'

const onlinePurchaseStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(1.6),
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'auto',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(1.6),
  },
  img: {
    width: '100%',
  },
  formSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  textField: {
    marginBottom: theme.spacing(2.4),
  },
  datePicker: {
    marginTop: theme.spacing(2.4),
    marginBottom: theme.spacing(2.4),
  },
  boldFont: {
    fontWeight: theme.typography.fontWeightBold,
  },
}))

export default onlinePurchaseStyles
